import { FunctionComponent, useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useLocation, useParams, useNavigate } from 'react-router-dom'
import { BackButton } from '@twa-dev/sdk/react'

import { EventStore } from 'stores'
import { EventType } from 'types'
import { FlexLayout } from 'layouts'
import { isDef } from 'utils'
import { useValueContext, ValueContext } from 'contexts'
import { PageSpinner, ConfirmModal } from 'components'

import { CurrentFooter, Footer } from './components'
import { Bottle, Breast, Pee, Poo, Sleep } from './screens'
import './styles.scss'

const componentsMap: Record<EventType, FunctionComponent<any>> = {
  [EventType.BREAST_LEFT]: Breast,
  [EventType.BREAST_RIGHT]: Breast,
  [EventType.BOTTLE]: Bottle,
  [EventType.SLEEP_DAY]: Sleep,
  [EventType.SLEEP_NIGHT]: Sleep,
  [EventType.POO]: Poo,
  [EventType.PEE]: Pee,
}

export const Event = observer(() => {
  const { id } = useParams()
  const { state } = useLocation()
  const navigate = useNavigate()
  const { babyStore, homeStore } = useValueContext()
  const type = state?.type
  const event = state?.event
  const current = state?.current
  const { selectedBaby } = babyStore
  const [store] = useState(() => new EventStore(id || '', type))
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (isDef(selectedBaby)) {
      store.setBaby(selectedBaby)
      store.init(event)
    }
  }, [event, selectedBaby, store])

  const Component = componentsMap[store.type as EventType]

  if (!Component) {
    return <BackButton />
  }

  const onDeleteConfirm = async () => {
    const result = await store.remove()
    if (result) {
      navigate('/home')
    }
  }

  return (
    <ValueContext.Provider value={{ eventStore: store, homeStore }}>
      <BackButton />
      <PageSpinner open={store.loading} delay={400} minVisibleTime={400} />
      <FlexLayout.Container className="event-screen with-mobile-indent" vertical>
        <Component current={current} />
        {current ? <CurrentFooter /> : <Footer onDelete={() => setOpen(true)} />}
        <ConfirmModal
          confirmLabel="Удалить"
          open={open}
          onSetOpen={setOpen}
          onActionClick={onDeleteConfirm}
        >
          Вы уверены, что хотите удалить событие?
        </ConfirmModal>
      </FlexLayout.Container>
    </ValueContext.Provider>
  )
})
